module.exports = function() {
  return new Worker(__webpack_public_path__ + "19dc827f77dd32b96909.worker.js");
};